import { compose } from "redux";

import { VehicleList } from "../src/vehiclesNew/VehicleList";
// @ts-ignore
import withAuthentication from "../src/withAuthentication";
// @ts-ignore
import { VEHICLES_LIST, permissions } from "../src/routes";

export default compose(withAuthentication(permissions[VEHICLES_LIST]))(
  VehicleList,
);
